import api from './api';

export const streamingService = {
  getQobuzAlbum: (albumId: string, headers?: Record<string, string>) =>
    api.get(`/api/streaming/qobuz/album?albumId=${encodeURIComponent(albumId)}`, { headers }),
  getQobuzAlbumDetail: (albumId: string) =>
    api.get(`/api/streaming/qobuz/album-detail?album_id=${encodeURIComponent(albumId)}`),
  getQobuzAlbumTracks: (albumId: string, headers?: Record<string, string>) =>
    api.get(`/api/streaming/qobuz/album-tracks?album_id=${encodeURIComponent(albumId)}`, { headers }),
  getQobuzStreamUrl: (trackId: string, formatId: number = 27, headers?: Record<string, string>) =>
    api.get(`/api/streaming/qobuz/stream-url?track_id=${encodeURIComponent(trackId)}&format_id=${formatId}`, { headers }),
};
